import React, { useEffect } from 'react';
import styles from '../styles/ProductInfo.module.css';

const ProductInfo = ({ product, categoryLabel, imageSrc, imageBackground, labels, onClose }) => {
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div className={styles.backdrop} role="presentation" onMouseDown={onClose}>
      <section
        className={styles.dialog}
        role="dialog"
        aria-modal="true"
        aria-labelledby="product-info-title"
        onMouseDown={event => event.stopPropagation()}
      >
        <button className={styles.close} type="button" onClick={onClose} aria-label={labels.close}>
          ×
        </button>

        <div className={styles.imagePanel}>
          {imageBackground ? (
            <div
              className={styles.backgroundImage}
              role="img"
              aria-label={product.title}
              style={{
                backgroundImage: `url('${imageBackground.src}')`,
                backgroundPosition: imageBackground.position || 'center',
                backgroundSize: imageBackground.size || 'cover',
              }}
            />
          ) : (
            <img src={imageSrc} alt={product.title} />
          )}
        </div>

        <div className={styles.details}>
          <p className={`${styles.category} ${categoryLabel === 'За енергия' ? styles.energyCategory : ''}`}>
            {categoryLabel}
          </p>
          <h2 id="product-info-title">{product.title}</h2>
          {product.price && <p className={styles.price}>{product.price}</p>}
          <p className={styles.description}>{product.description}</p>
          <h3>{labels.ingredients}</h3>
          <p className={styles.ingredients}>{product.ingredients}</p>
        </div>
      </section>
    </div>
  );
};

export default ProductInfo;
